export default __webpack_public_path__ + "static/media/black_flower.f62528c5.svg";